import React from 'react';
import { Skeleton } from '@c2fo/react-components';

export const HomepageInvoiceUploadCardSkeleton: React.FC = (props) => <Skeleton variant={'rect'} height={275} />;
